/** Pure logic for the Apps page (kept out of the view so it is unit-testable). */

export function wrapIndex(index: number, length: number): number {
  if (length <= 0) return 0;
  return ((index % length) + length) % length;
}

export function nextIndex(index: number, length: number): number {
  return wrapIndex(index + 1, length);
}

export function prevIndex(index: number, length: number): number {
  return wrapIndex(index - 1, length);
}

export interface StoreButtonState {
  label: string;
  href: string;
  enabled: boolean;
  caption: string;
}

export function storeButtonState(label: string, url: string | undefined): StoreButtonState {
  const href = (url ?? "").trim();
  return href
    ? { label, href, enabled: true, caption: "" }
    : { label, href: "", enabled: false, caption: "Not published yet" };
}
